module.exports = __webpack_public_path__ + "static/img/37.b924df0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mohu/3/37.png
// module id = JNVL
// module chunks = 0